// @flow
import VendingMachinePageRoot from './VendingMachinePageRoot';

export default VendingMachinePageRoot;
